import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const CNSModules = () => {
  const modules = ['Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5'];

  const subtopicsData = {
    'Module 1': [
      { name: 'Fundamentals of Number Theory', path: '/cns-m1-s1' }
    ],
    'Module 2': [
      { name: 'Caesar, Playfair, Vigenere, Hill ciphers', path: '/cns-m2-s1' },
      { name: 'DES, AES, IDEA, Block Cipher Operation, RC4', path: '/cns-m2-s2' }
    ],
    'Module 3': [
      { name: 'Asymmetric key cryptographic techniques', path: '/cns-m3-s1' },
      { name: 'Key distribution and Key exchange protocols, Diffie-Hellman Key Exchange, Man-in-the-Middle Attack', path: '/cns-m3-s2' }
    ],
    'Module 4': [
      { name: 'Requirements for Hash Functions, Security of Hash Functions', path: '/cns-m4-s1' },
      { name: 'Message Digest (MD5)', path: '/cns-m4-s2' },
      { name: 'Secure Hash Function (SHA)', path: '/cns-m4-s3' },
      { name: 'Birthday Attack, HMAC', path: '/cns-m4-s4'  }
    ],
    'Module 5': [
      { name: 'Authentication Requirements, Authentication Functions, Message Authentication Codes', path: '/cns-m5-s1' },
      { name: 'Digital Signature Authentication, Authentication Protocols, Digital Signature Standards, RSA Digital Signature, Elgamal based Digital Signature', path: '/cns-m5-s2' },
      { name: 'Authentication Protocols, Kerberos, X.509 Authentication Service', path: '/cns-m5-s3' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Cryptography and Network Security</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-CNSModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CNSModules;
